module.exports = __webpack_public_path__ + "img/citizen.bff1df4f.png";